import { Fragment } from "react";
import classNames from "classnames";

import styles from "./AscAdminAction.module.scss";
import { LoadingSpinnerIcon } from "../AscIcons";

export interface AscAdminActionOptionProps {
  title: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  hidden?: boolean;
  loading?: boolean;
}

export interface AscAdminActionProps {
  className?: string;
  options?: AscAdminActionOptionProps[];
  option1?: string;
  option2?: string;
  option3?: string;
  clickOption1?: (e?: any) => void;
  clickOption2?: (e?: any) => void;
  clickOption3?: () => void;
}

export default function AscAdminAction({
  className,
  options,
  option1,
  option2,
  option3,
  clickOption1,
  clickOption2,
  clickOption3,
}: AscAdminActionProps) {
  return (
    <div
      data-testid="asc-admin-action"
      className={classNames(styles.ground, className)}
    >
      {options && options.length > 0 ? (
        options.map((option, index) => (
          <span
            key={index}
            onClick={() => !option?.disabled && option?.onClick()}
            className={classNames(
              styles.option,
              option?.loading && styles.loading,
              option?.disabled && styles.disabled,
              option?.hidden && styles.hidden,
              option?.className
            )}
          >
            {option?.title} {option?.loading ? <LoadingSpinnerIcon /> : ""}
          </span>
        ))
      ) : (
        <Fragment>
          <span onClick={clickOption1} className={styles.option}>
            {option1}
          </span>
          <span onClick={clickOption2} className={styles.option}>
            {option2}
          </span>
          {option3 && (
            <span onClick={clickOption3} className={styles.option}>
              {option3}
            </span>
          )}
        </Fragment>
      )}
    </div>
  );
}
